import { motion } from "framer-motion";
import { ReactNode } from "react";

interface OnboardingStepProps {
  step: number;
  totalSteps: number;
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const OnboardingStep = ({ step, totalSteps, title, subtitle, children }: OnboardingStepProps) => {
  return (
    <motion.div
      className="flex-1 flex flex-col"
      initial={{ opacity: 0, x: 30 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -30 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    >
      {/* Progress bar */}
      <div className="flex gap-2 mb-10">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <div key={i} className="h-[3px] flex-1 rounded-full overflow-hidden bg-muted">
            <motion.div
              className="h-full bg-primary rounded-full"
              initial={{ width: i < step ? "100%" : "0%" }}
              animate={{ width: i <= step ? "100%" : "0%" }}
              transition={{ duration: 0.8, delay: i === step ? 0.2 : 0, ease: "easeOut" }}
            />
          </div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.15, duration: 0.5 }}
      >
        <h2 className="font-display text-2xl font-semibold text-foreground mb-1.5">{title}</h2>
        {subtitle && <p className="text-muted-foreground text-sm mb-8 leading-relaxed">{subtitle}</p>}
      </motion.div>

      <div className="flex-1 flex flex-col gap-4 mt-1">
        {children}
      </div>
    </motion.div>
  );
};

export default OnboardingStep;
